import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import classNames from 'classnames';
import { makePrioStyles } from '../../../theme/utils';
import { useAmberSearchGlobalUrl } from '../hooks/useAmberSearchGlobalUrl';

const useStyles = makePrioStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.colors.application.background.light,
  },
  iframe: {
    flex: 1,
    width: '100%',
    height: '100%',
    border: 'none',
  },
}));

interface AmberSearchMePageProps {}

export const AmberSearchMePage: React.FC<AmberSearchMePageProps> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { data: amberSearchUrl, isLoading } = useAmberSearchGlobalUrl();

  if (isLoading) {
    return null;
  }

  if (!amberSearchUrl) {
    return <Navigate to="/module/prio/projects/me/dashboard" replace />;
  }

  return (
    <div className={classNames(classes.root)}>
      <iframe
        src={amberSearchUrl}
        className={classes.iframe}
        title={t('profile:projectsProfileNavigation.amberSearch')}
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      />
    </div>
  );
};

export default AmberSearchMePage;
